export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        width: 'inherit',
    },
    parentMultipleProgressBarsContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'row',
        gap: FOUNDATIONS.spacing_100,
    },
    multipleProgressBarsContainer: {
        width: 'inherit',
    },
});
//# sourceMappingURL=commonStyles.js.map